import { createFileRoute } from '@tanstack/react-router';

import { PersonInformation } from '~/features/workspace/person/person-information';

/** A person's contact, whom they report to, and their role. */
export const Route = createFileRoute('/_app/business/people/$userId/information')({ component: PersonInformation });
